<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header class="mdl-layout__header">
      <div class="mdl-layout__header-row page-header">
        <back-navigator></back-navigator>
        <span id="toolbar-title" class="mdl-layout-title">{{ $t('message.pageTitle') }}</span>
        <div class="mdl-layout-spacer"></div>
        <theme-switcher iconTheme="light" :userLang="userLocale"></theme-switcher>
      </div>
    </header>
    <div class="horizontalLine"></div>
    <div class="privacy-policy-content">
      <h6><i>Last updated: March 2, 2026</i></h6>
      <h6>This Privacy Policy explains how Pollscape collects, uses and transfers your
        information.</h6>
      <h5 id="what-is-collected"><b>What do we collect?</b> (<a href="privacyPolicy#what-is-collected">link</a>)</h5>
      <ul>
        <li>
          <h6>These are the only personally identifiable information that we collect:</h6>
        </li>
        <ul>
          <li>
            <h6>The email-id of the Google or Facebook account you use to sign-in</h6>
          </li>
          <li>
            <h6>Profile image for the above mentioned Google/Facebook account</h6>
          </li>
          <li>
            <h6>User name for the above mentioned Google/Facebook account</h6>
          </li>
        </ul>
        <li>
          <h6>When you vote for an anonymous poll, we use your IP address to check if you have already voted for the poll. Hence, we also store it in the database.
            However, your IP address is not linked to your user profile in any manner even after you sign in. It is just used to prevent duplicate votes.
          </h6>
        </li>
        <li>
          <h6>Anonymous usage statistics are collected through Google Analytics in order to improve the app. You can check the <a href="/cookiePolicy">cookie policy</a> for more details.</h6>
        </li>
        <li>
          <h6>The Android app for Pollscape uses Admob by Google and Facebook Audience Network to display ads. Since, the app does not have any access to personal
            information like location, contacts, SMS, etc., the ad network doesn't have access to those information as
            well. You can choose to receive targeted ads or not from the app GDPR popup.
          </h6>
        </li>
        <ul>
          <li>
            <h6>Admob is an advertising service provided by Admob Google Inc. Personal data collected: Cookie and
                usage data. Place of processing: USA (<a href="https://www.google.com/policies/privacy/">Privacy Policy</a>)
            </h6>
          </li>
          <li>
            <h6>
              Facebook Audience Network is an advertising service provided by Facebook. Personal Data collected: Cookie and Usage Data. Place of processing: USA (<a href="https://www.facebook.com/about/privacy">Privacy policy</a>).
            </h6>
          </li>
        </ul>
        <li>
          <h6>The Android app also collects anonymous usage statistics and crash reports to improve the app. You can turn it on/off anytime by going to the app's settings page.</h6>
        </li>
        <li>
          <h6>Pollscape developer can ask you for some additional information when trying to debug issues in the app.
            These information will only be used to solve the issue at hand. Nothing will be shared with any 3rd party
            service.</h6>
        </li>
      </ul>

      <br/>
      <h5 id="exporting-data"><b>Exporting your data</b> (<a href="privacyPolicy#exporting-data">link</a>)</h5>
      <ul>
        <li><h6>You can export a copy of the data of your Pollscape account if you want to 
          back it up or use it with a service other than Pollscape.</h6></li>
        <li><h6>To export your data, head over to the <a href="/userProfile">user profile</a> 
          page and click on 'Export Data' button.</h6></li>
      </ul>

      <br/>
      <h5 id="deletion-policy"><b>Data Deletion Policy</b> (<a href="privacyPolicy#deletion-policy">link</a>)</h5>
      <ul>
        <li><h6>You can choose to delete your data from Pollscape anytime you want by visiting 
          the <a href="/userProfile">user profile</a> page and clicking on 'Delete Account' button.
          All the polls you have created along with all your personal details will be deleted 
          within 30 days of your request.</h6></li>

        <li><h6>We do have an inactive account policy according to which, accounts that are inactive
          for longer periods of time will be automatically deleted. To prevent this from happening, we
          suggest you to log in and use Pollscape at least once every 18 months.</h6></li>
      </ul>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import backNavigator from './BackNavigationComponent'
  import themeSwitcher from './ThemeSwitcher'
  import footerComponent from './Footer'

  const messages = {
    en: {
      message: {
        pageTitle: 'Privacy Policy'
      }
    },
    hi: {
      message: {
        pageTitle: 'गोपनीयता नीति'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    components: {
      backNavigator: backNavigator,
      themeSwitcher: themeSwitcher,
      footerComponent: footerComponent
    },
    data () {
      return {
        userLocale: i18n.locale
      }
    },
    mounted () {
      document.title = i18n.t('message.pageTitle')
      this.userLocale = i18n.locale
    }
  }
</script>


<style scoped>
  .privacy-policy-content {
    padding: 0 25px 25px 25px;
    margin-right: 25px;
  }

  a {
    font-size: 1em;
    font-weight: 400;
    color: var(--secondary-color);
  }

  h5 > b {
    font-weight: 600;
  }

  h6 {
    font-size: 1.30em;
    font-weight: 400;
    line-height: 1.25;
  }

  ul {
    margin-left: 20px;
  }

  li {
    margin: -40px;
    padding: 0.2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue